var map = {
	"./AnswerQuestionCard/example.json": [
		96692,
		6692
	],
	"./CarouselCard/example.json": [
		85041,
		5041
	],
	"./FillBlankDropdownCard/example.json": [
		51591,
		1591
	],
	"./FillBlankTextCard/example.json": [
		34995,
		4995
	],
	"./GalleryCard/example.json": [
		4955,
		4955
	],
	"./McqCard/example.json": [
		69223,
		9223
	],
	"./OpinionCard/example.json": [
		63670,
		3670
	],
	"./QuestionAndAnswerCard/example.json": [
		92978,
		2978
	],
	"./RandomGeneratorCard/example.json": [
		21890,
		1890
	],
	"./SortableCard/example.json": [
		56223,
		6223
	],
	"./SortableColumnsCard/example.json": [
		32769,
		2769
	],
	"./SpotMistakeCard/example.json": [
		75175,
		5175
	],
	"./StaticCard/example.json": [
		64012,
		4012
	],
	"./ThoughtShowerCard/example.json": [
		88225,
		8225
	],
	"./TrueFalseCard/example.json": [
		85298,
		5298
	],
	"./VideoQuestionCard/example.json": [
		42435,
		2435
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 40029;
module.exports = webpackAsyncContext;